import AddressFormatter from '@fragaria/address-formatter';

import { BusinessAddress } from '@/types/customer';

export const businessAddressToAddressFormatterInput = (
  address: BusinessAddress,
): AddressFormatter.Input => {
  return {
    state: address.state ?? undefined,
    city: address.city ?? undefined,
    postcode: address.zipCode ? String(address.zipCode) : undefined,
    country: address.country ?? undefined,
    street: address.streetAddress ?? undefined,
    houseNumber: address.complement ?? undefined,
  };
};
